/**
 * @file
 * Behaviors for the views.
 */
(function($, Drupal) {
    'use strict';

    const {COLORS, log} = Drupal.theme;

    /**
     * Attaches filters behavior to the views.
     *
     * To hide the submit, add the class "js-hide-submit". And add "hide-submit"
     * for the corresponding style.
     *
     * @type {Drupal~behavior}
     *
     * @prop {Drupal~behaviorAttach} attach
     */
    Drupal.behaviors.view = {
        namespace: 'view',
        debug: false,

        // Selectors
        containerClass: 'view',
        selectors: {
            submit: '.js-form-submit',
            inputs: '.view-filters input, .view-filters select',
        },

        // Classes
        classHideSubmit: 'js-hide-submit',

        /**
         * Basic log function.
         *
         * @param {Object} args
         */
        log(...args) {
            log(this.debug, COLORS.GREEN, this.namespace, args);
        },

        /**
         * Executed on page load and every request, including Ajax requests.
         *
         * @param {Object} context
         *   Part of the page that change, on a page load, this will be the
         *   document.
         */
        attach(context) {
            if (context.classList && context.classList.contains(this.containerClass)) {
                $(context)
                    .once(this.namespace)
                    .each((index, element) => {
                        this.init($(element));
                    });
            } else {
                $('.' + this.containerClass, context)
                    .once(this.namespace)
                    .each((index, element) => {
                        this.init($(element));
                    });
            }
        },

        /**
         * @param {jQuery} $container
         */
        init($container) {
            this.log('init');

            if ($container.hasClass(this.classHideSubmit)) {
                this.initHideSubmit($container);
            }
        },

        /**
         * Trigger the submit on inputs change.
         *
         * @param {jQuery} $container
         */
        initHideSubmit($container) {
            this.log('initHideSubmit');

            const $inputs = $container.find(this.selectors.inputs);

            $inputs.on('change', () => {
                this.log('trigger hidden submit');
                const $submit = $container.find(this.selectors.submit);
                $submit.trigger('click');
            });
        },
    };
})(jQuery, Drupal);
